import { createContext} from "react";

export  const FeatureContext = createContext();